import { HttpParams } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';


@Component({
    selector: 'app-payment-success',
    templateUrl: './payment-success.component.html',
    styleUrls: ['./payment-success.component.css'],
    standalone: false
})
export class PaymentSuccessComponent implements OnInit {

  constructor(
    private activeRoutes: ActivatedRoute,
    private router: Router,

    )
    { }

  userTIN : any;

  ngOnInit(): void {

    this.userTIN = this.activeRoutes.snapshot.paramMap.get("tin")

  }

  backToHome()
  {
    // this.router.navigate(["/user-panel/assessment"]);
    this.router.navigate(["/user-panel/home"]);
  }

  backToTaxAndPayment()
  {
    this.router.navigate(["/user-panel/tax-and-payment"]);
  }

}
